import React, {Component} from 'react';
import config from 'react-global-configuration';
import { Collapse, Button, Input, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
//import {Card, CardBody, CardText} from 'reactstrap';
import {Card} from 'react-bootstrap';
import {Link} from "react-router-dom";
import axios from "axios";
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import ReactTooltip from 'react-tooltip';
import Select from 'react-select';
import $ from 'jquery';
import DatePicker from "react-datepicker";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { List } from 'react-virtualized';
import SimpleReactValidator from 'simple-react-validator';
import Switch from "react-switch";

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class Onboarding extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            brand_file_uploaded: [],
            mvalue: { year: new Date().getFullYear(), month: 11 },
            _notificationSystem: null,
            timer: null,
            loading: true,
            isSubmit: false,
            file_name: "",
            notify: null,
            activer:[],
            activer_2:[],
            activer_noti:[],
            activer_noti_2:[],
            is_download: false,
            newUserModel: false,
            errorModel: false,
            noErrorModel: false,
            file_id_got: null,
            report_file_name: null,
            error_message: null,
            error_message_header: null,
            open_instructions: false,
            emiMenus:[],
            report_download_name: null,
            action_type: 'Add New User',
            logged_user_type: 'Internal',
            userType: 'External',
            userGroup: 'Brand',
            userSubGroup: 'BrandEMI',
            contact_title: '',
            selected_brand: '',
            selected_brand_code: '',
            selected_brand_2: [],
            brand_list: [],
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            password: '',
            confirm_password: '',
            newBrandModel: false,
            brandName: '',
            update_disable: false
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };


    componentWillMount(){
        this.validator = new SimpleReactValidator();
    }
    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        this.getPartyID();
        //var _notificationSystem = this.refs.notificationSystem;
        // this.getBrandUploadedData();
    }

    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            //console.log(response.data);
            response.data.map((values, index) => {
                console.log(values.party_id);
                this.setState({
                    party_master_id: values.party_id
                })
            })
            this.setState({
                party_id_mapper: response.data
            });
            $('#party_showTable').DataTable();
            this.setState({
                loading: false,
                user_id: decoded._id
            });
            this.getBrandUploadedData();
        });
    }


    getFileExtension(filename) {
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    }

    openInstructions(){
        this.setState({
            open_instructions: !this.state.open_instructions
        });
        
    }

    onChangeInput(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    onChangeHandler = event => {
        if (event.target.files.length == 0){
            this.handleNotificationClick("tr", 3, "Please select a file");
        }
        else{
            var file = event.target.files[0];
            var ext = this.getFileExtension(file.name);
            if (ext === 'csv') {
                this.setState({
                    selectedFile: file,
                    file_name: file.name
                });
            } else {
                this.handleNotificationClick("tr", 3, "Please upload valid file");
                this.setState({
                    selectedFile: file
                });
            }
        }
        
    };

    handleChange(checked) {
        console.log(this.state.checked);
        //console.log(e.target.value);
        this.setState({
            checked
        });
        //this.setState({
        //    changedItems: {...this.state.changedItems, [id]:e.target.value},
        //    isChange: true
        //});
    }

    toggleNewUserModel(modal_type) {
        this.validator.hideMessages();
        this.setState({
            newUserModel: !this.state.newUserModel,
            action_type: 'Add New User'
        })
    }

    toggleNewBrandModel(modal_type) {
        this.validator.hideMessages();
        this.setState({
            newBrandModel: !this.state.newBrandModel,
            action_type: 'Add New Brand'
        })
    }

    getBrandUploadedData(){
        if ($.fn.DataTable.isDataTable('#brandViewTable')) {
            $('#brandViewTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/brandemi/get_party_list', {
            party_type1: 'Brand'
        }, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response.data._embedded.manufacturers);
            let brand_list = [];
            this.setState({
                brand_list: [],
                selected_party: null
            });
            response.data._embedded.manufacturers.map((values, index) => {
                brand_list.push({value: values.id, label: values.manufacturerDisplayName});
                let status = false;
                let status2 = false;
                if(values.email==='yes') { status = true;}
                if(values.notification==='yes') { status2 = true;}
                this.setState({
                    activer: {...this.state.activer, [values.id]:status },
                    activer_noti: {...this.state.activer_noti, [values.id]:status2 }
                });
            });
            this.setState({
                brand_file_uploaded: response.data._embedded.manufacturers,
                brand_list: brand_list,
                loading: false
            });
            $('#brandViewTable').DataTable({
                "oLanguage": {
                    "sEmptyTable": "No brands onboarded"
                }
            });
        });
        return null;
    }

    downloadCSV = (file_id, file_value) => {
        this.setState({
            is_download:false
        });
        let xhr = $.ajax({
            url: config.get('API_URL') + "/brandemi/download_csv?file_id=" + file_id,
            type: 'GET',
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName= null;
                console.log(file_value);
                console.log(xhr.getResponseHeader('Content-Disposition'));
                if(file_id == '7md38Hhdad3_brand_product_master_template.csv'){
                    fileName = 'products-template.csv';
                }
                else{
                    fileName= file_value;
                }
                //alert(fileName);
                let rfile = fileName.replace(/\"/g, "");
                // console.log(fileName);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                console.log(a);
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr
        })
    };

    downloadReportCSV = (file_id, file_value, file_value2) => {
        this.setState({
            is_download:false
        });
        let xhr = $.ajax({
            url: config.get('API_URL') + "/brandemi/download_report_csv?file_id=" + file_value,
            type: 'GET',
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName= file_value2;
                console.log(file_value);
                console.log(xhr.getResponseHeader('Content-Disposition'));
                //alert(fileName);
                let rfile = fileName.replace(/\"/g, "");
                // console.log(fileName);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                console.log(a);
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr
        })
    };

    updateBrandValue = (valuer) => {
        this.setState({
            selected_brand: valuer.label,
            selected_brand_2: [{value: valuer.value, label: valuer.label}],
            selected_brand_code: valuer.value,
            party_master_id: valuer.value,
            loading: false
        });
        
    };

    goBack = () => {
        this.props.history.push('/admin/brand-emi')
    }

    
    

    uploadDropdownHandler = () => {
        this.setState({
            newUserModel: true
        })
    }

    uploadDropdownHandler2 = () => {
        this.setState({
            newBrandModel: true
        })
    }

    toggleErrorModel() {
        this.setState({
            errorModel: !this.state.errorModel
        });
    }

    downloadReport(){
        console.log(this.state.report_file_name);
        this.downloadReportCSV.bind(this, 1, this.state.report_file_name, this.state.report_download_name);
    }



    toggleNoErrorModel() {
        this.setState({
            noErrorModel: !this.state.noErrorModel
        });
    }

    changeTitle(e) {
        this.setState({
            contact_title : e.target.value
        })
    }

    gotoUploadedFile(){
        let pusher = '/admin/brand-viewer/' + this.state.file_id_got
        this.props.history.push(pusher)
    }

    addUser() {
        // var kill = 0;
        // console.log("Nay");
        // if((this.state.firstName.trim()).length == 0){
        //     this.handleNotificationClick("tr", 3, "Enter valid brand name");
        //     kill = 1;
        // }
        // if((this.state.lastName.trim()).length == 0){
        //     this.handleNotificationClick("tr", 3, "Enter valid brand name");
        //     kill = 1;
        // }
        // if(this.state.password.length < 6){
        //     this.handleNotificationClick("tr", 3, "Password length must be greater than 6");
        //     kill = 1;
        // }
        // if(this.state.password != this.state.confirm_password){
        //     this.handleNotificationClick("tr", 3, "Passwords do not match");
        //     kill = 1;
        // }

        // if(isNaN(this.state.phone) && this.state.phone.length != 10){
        //     this.handleNotificationClick("tr", 3, "Enter valid mobile number");
        //     kill = 1;
        // }
        if (this.validator.allValid()) {
            console.log("yay");
            const data = new FormData();
            data.append('firstName', this.state.firstName);
            data.append('lastName', this.state.lastName);
            data.append('email', this.state.email);
            data.append('phone', this.state.phone);
            data.append('password', this.state.password);
            data.append('contact_title', this.state.contact_title);
            data.append('brand_code', this.state.selected_brand_code);
            data.append('brand_name', this.state.selected_brand);
            
            //console.log(this.state.selected_brand_code);

            axios.post(config.get('API_URL') + '/brandemi/brand_user_register', data, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                if(response.data.flag == '1'){
                    this.handleNotificationClick("tr", 1, "User is successfully registered");
                    this.setState({
                        firstName: '',
                        lastName: '',
                        email: '',
                        phone: '',
                        password: '',
                        confirm_password: '',
                        contact_title: '',
                        selected_brand_code: '',
                        selected_brand: '',
                        selected_brand_2: []
                    })
                }
                else if(response.data.flag == '2'){
                    this.handleNotificationClick("tr", 3, "User already exists");
                }
                else if(response.data.flag == '3'){
                    this.handleNotificationClick("tr", 3, "Something wrong");
                }
                // console.log("abbaba")
                // console.log(response);
                if (response.data.error) {
                    //this.props.handleClick("tr", 3, "Something went wrong");
                } else {
                    //this.props.handleClick("tr", 1, "Record has been successfully Added.");
                    this.setState({
                        newUserModel: false,
                    });
                }
            });
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
        }
    }


    addBrand() {
        // console.log("Nay");
        // console.log(this.validator.allValid())
        // if (this.validator.allValid()) {
            console.log("Yay");


            this.setState({
                loading: true
            })
            let varu = this.state.brandName.trim();
            if(varu.length == 0){
                this.handleNotificationClick("tr", 3, "Enter valid brand name");
                this.setState({
                    loading: false
                })
            }
            else{
                const data = new FormData();
            data.append('brandName', this.state.brandName);
            axios.post(config.get('API_URL') + '/brandemi/brand_register_new', data, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                if(response.data.flag == '0'){
                    this.handleNotificationClick("tr", 1, "Brand Upload Successful");
                    this.getBrandUploadedData();
                }
                else if(response.data.flag == '1'){
                    this.handleNotificationClick("tr", 3, "Duplicate Brand");
                }
                else if(response.data.flag == '2'){
                    this.handleNotificationClick("tr", 3, "Something wrong");
                }
                // console.log("abbaba")
                // console.log(response);
                }).catch(error => {
                     if (error.response && error.response.data && error.response.data.errorMessage) {
                          this.handleNotificationClick("tr", 3, error.response.data.errorMessage);
                     } else {
                           this.handleNotificationClick("tr", 3, "Unexpected error occurred.");
                     }
                     }).finally(() => {
                      this.setState({ loading: false });
                     });
            this.setState({
                loading: false
            })
            }
            
        // } else {
        //     this.validator.showMessages();
        //     // rerender to show messages for the first time
        //     // you can use the autoForceUpdate option to do this automatically`
        // }
    }

    changeEmailStatus(id, checked) {
        this.setState({
            activer: {...this.state.activer, [id]:checked },
            activer2: {...this.state.activer2, [id]:checked }
        })
    }

    changeNotiStatus(id, checked) {
        this.setState({
            activer_noti: {...this.state.activer_noti, [id]:checked },
            activer_noti_2: {...this.state.activer_noti_2, [id]:checked },
        })
    }
    

    activeHandler() {
        this.setState({
            isSubmit: true,
            update_disable: true,
            loading: true
        });
        if((this.state.activer2.length == 0 || this.state.activer2.length == 'undefined') && (this.state.activer_noti_2.length == 0 || this.state.activer_noti_2.length == 'undefined')){
            this.handleNotificationClick("tr", 3, "No changes applicable");
            this.setState({
                isSubmit:false,
                update_disable: false,
                loading:false
            });
        }
        else{
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        data.append('userID', decoded._id);
        data.append('mappings', JSON.stringify(this.state.activer2));
        data.append('mappings2', JSON.stringify(this.state.activer_noti_2));
        data.append('userGroup', decoded.userGroup);
        data.append('party_master_id', this.state.party_master_id);
        axios.post(config.get('API_URL') + "/brandemi/active_email_noti_config", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                console.log(res);
                if(res.data.flag == '1'){
                    this.handleNotificationClick("tr", 1, 'Record has been updated successfully');
                    this.setState({
                        isSubmit:false,
                        update_disable:false,
                        loading:false
                    });
                    //this.props.history.push('/admin/brand-product-master')
                } 
                else {
                    this.handleNotificationClick("tr", 3, "Unable to update. Please try after some time.");
                    this.setState({
                        isSubmit:false,
                        update_disable:false,
                        loading:false
                    });
                }
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Something Wrong!");
                this.setState({
                    isSubmit:false,
                    update_disable:false,
                    loading:false
                })
            })
        }
    };


    render() {

        let brand_render_list = this.state.brand_list;
        // const MenuList = props => {
        //     const rows = props.children;
        //     let no_of_rows = 0;
        //     let drop_down_heigth = 0
        //     if(rows.length!== undefined){
        //         no_of_rows = rows.length;
        //         if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
        //         else{
        //             drop_down_heigth = 300;
        //         }

        //     }
        //     const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
        //         <div key={key} style={style}>{rows[index]}</div>
        //     );

        //     return (
        //         <List
        //             style={{ width: '100%' }}
        //             width={300}
        //             height={drop_down_heigth}
        //             rowHeight={30}
        //             rowCount={no_of_rows}
        //             rowRenderer={rowRenderer}
        //         />
        //     )
        // }
        this.validator.purgeFields();
            let confirmPasswordError = '';
            let passwordError = '';
        if(config.get('API_URL')!='https://sparcs.innoviti.com/api/node') {
            if (this.state.action_type == 'Add New User' || this.state.password != '') {
                confirmPasswordError = this.validator.message('confirm_password', this.state.confirm_password, `required|in:${this.state.password}`, {messages: {in: 'Passwords need to match!'}});
                passwordError = this.validator.message('password', this.state.password, 'required|min:6|max:20');
            } else {
                confirmPasswordError = '';
                passwordError = '';
            }
        }

        const customStyles = {
            control: provided => ({
                ...provided,
                padding: "0px",
                minHeight: "38px",

            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "38px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
        };

        let brand_file_data = this.state.brand_file_uploaded.map((value, index) =>{
            let timer2 = new Date(value.crtupdDate)
            timer2.setHours( timer2.getHours() + 5 );
            timer2.setMinutes( timer2.getMinutes() + 30 );
            let timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');
            //let timer3 = timer2.getDay() + "-" + timer2.getMonth() + "-" + timer2.getFullYear() + " " + timer2.getHours() + ":" + timer2.getMinutes();
            return (
                <tr key={index + 1}>
                <td>{value.manufacturerDisplayName}</td>
                <td>{timer3}</td>
                {/* <td><Switch className="react-switch" height={20} width={38} id={value.id + '_'} onChange={this.changeEmailStatus.bind(this, value.id)} checked={(this.state.activer[value.id])? true : false}></Switch></td>
                <td><Switch disabled={true} className="react-switch" height={20} width={38} id={value.id + '_'} onChange={this.changeNotiStatus.bind(this, value.id)} checked={(this.state.activer_noti[value.id])? true : false}></Switch></td> */}
            </tr>
            )
        });

        return (
            <div className="content longcontent">
            <div className="card-query-builder top-pad-5">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />   
                <div className="col-md-12" >
                    <div className="card">
                        <div className='sweet-loading'>
                            <BeatLoader
                                css={override}
                                sizeUnit={"px"}
                                size={20}
                                color={'#123abc'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="header">
                            <h4 className="title pull-left">Onboarding</h4>
                            <button onClick={this.uploadDropdownHandler} className="btn btn-primary btn-capitalize pull-right">Add Brand Users</button>{' '}
                            <button onClick={this.uploadDropdownHandler2} className="btn btn-primary btn-capitalize pull-right">Add Brand</button>{' '}
                        </div>
                        <div className="content">
                            <div className="row">
                                <div className="container-fluid">
                                    <div className="table-full-width table-responsive-bemi notablerightmargin top-pad-5">    
                                        <table className="table table-striped table-hover" id="brandViewTable">
                                            <thead>
                                                <tr>
                                                    <th>Party Name</th>
                                                    <th>Create Time</th>
                                                    {/* <th>Email</th>
                                                    <th>Notifications</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {brand_file_data}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className ="col-md-12">
                                    {/* <button disabled={this.state.update_disable} onClick={this.activeHandler.bind(this)} className="btn btn-primary btn-capitalize pull-right">Update</button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal isOpen={this.state.newUserModel} toggle={this.toggleNewUserModel.bind(this)} >
                    <ModalHeader toggle={this.toggleNewUserModel.bind(this)}>{this.state.action_type}</ModalHeader>
                                <ModalBody className="user_form_fields">
                                    <h5>User Details</h5>
                                    <div className="row">
                                        <div className="col-md-2 col-sm-12">
                                            <FormGroup>
                                                <Label for="password">Title*</Label>
                                                <select name="contact_title" className="form-control"
                                                    value={this.state.contact_title} onChange={this.changeTitle.bind(this)}>
                                                    <option value=" ">Select</option>
                                                    <option value="Mr">Mr</option>
                                                    <option value="Mrs">Mrs</option>
                                                    <option value="Ms">Ms</option>

                                                </select>
                                                {this.validator.message('contact_title', this.state.contact_title, 'required')}
                                            </FormGroup>
                                        </div>
                                        <div className="col-md-6 col-xs-12">
                                            <FormGroup>
                                                <Label for="firstName">First Name*</Label>
                                                <Input id="firstName" name="firstName" value={this.state.firstName}
                                                       onChange={this.onChangeInput.bind(this)}/>
                                                {this.validator.message('firstName', this.state.firstName, 'required')}
                                            </FormGroup>
                                        </div>

                                        <div className="col-md-4 col-xs-12">
                                            <FormGroup>
                                                <Label for="lastName">Last Name*</Label>
                                                <Input id="lastName" name="lastName" value={this.state.lastName}
                                                       onChange={this.onChangeInput.bind(this)}/>
                                                {this.validator.message('lastName', this.state.lastName, 'required')}
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 col-sm-12">
                                            <FormGroup>
                                                <Label for="eamil">Email*</Label>
                                                <Input id="email" name="email" autoComplete="new-password" value={this.state.email} onChange={this.onChangeInput.bind(this)}/>
                                                {this.validator.message('email', this.state.email, 'required|email')}
                                            </FormGroup>
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <FormGroup>
                                                <Label for="phone">Phone*</Label>
                                                <Input id="phone" name="phone" autoComplete="new-password" value={this.state.phone}
                                                    onChange={this.onChangeInput.bind(this)}/>
                                                {this.validator.message('phone', this.state.phone, 'required|phone')}
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {config.get('API_URL')!='https://sparcs.innoviti.com/api/node'?
                                            <div>
                                                <div className="col-md-6 col-sm-12">
                                                    <FormGroup>
                                                        <Label for="password">Password*</Label>
                                                        <Input id="password" name="password" type="password" autoComplete="new-password"
                                                               value={this.state.password}
                                                               onChange={this.onChangeInput.bind(this)}/>

                                                        {passwordError}
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-6 col-sm-12">
                                                    <FormGroup>
                                                        <Label for="confirm_password">Confirm Password*</Label>
                                                        <Input
                                                            label={!this.validator.fieldValid('confirm_password') && 'Passwords need to match!'}
                                                            name='confirm_password'
                                                            type='password'
                                                            autoComplete="new-password"
                                                            value={this.state.confirm_password}
                                                            onChange={this.onChangeInput.bind(this)}/>

                                                        {confirmPasswordError}
                                                    </FormGroup>
                                                </div>
                                            </div>
                                            : null
                                        }
                                    </div>
                                    <div className="ro-sep"></div>
                                    <h5>
                                        Additional Data
                                    </h5>
                                    <div className="row">
                                        <div className="col-md-6 col-sm-12">
                                            <FormGroup>
                                                <Label for="org">Organization* </Label>
                                                <Select name={"organization"}
                                                    value={this.state.selected_brand_2}
                                                    onChange={this.updateBrandValue.bind(this)}
                                                    options={brand_render_list}
                                                    placeholder="Select Organization"
                                                    // isClearable={true}
                                                />
                                                {this.validator.message('organization', this.state.selected_brand, 'required')}
                                            </FormGroup>
                                        </div>
                                        <div className="col-md-6 col-xs-12">
                                            <FormGroup>
                                                <Label for="Designation">Designation</Label>
                                                <Input id="Designation" name="designation" value={this.state.designation}
                                                       onChange={this.onChangeInput.bind(this)}/>

                                            </FormGroup>
                                        </div>

                                    </div>
                                    {/* <div className="row">
                                        <div className="col-md-6 col-xs-12">
                                            <FormGroup>
                                                <Label for="Account_Expiry_Date">Account Expiry Date</Label>
                                                <DatePicker
                                                    dateFormat="yyyy-MM-dd"
                                                    selected={Date.parse(this.state.account_expiry_date)}
                                                    onChange={this.handleFromChange}
                                                    minDate={new Date()}
                                                />

                                            </FormGroup>
                                        </div>

                                        <div className="col-md-6 col-xs-12">
                                            <FormGroup>
                                                <Label for="upload">Upload Onboarding Document</Label>
                                                <input type="file" name="file" className="form-control-file" onChange={this.onChangeHandler} />
                                                {this.state.action_type=='Edit User' || this.state.action_type=='Activate User'?
                                                    <a href="#"  onClick={this.downloadFile.bind(this)}>{this.state.edit_file}</a>: null}


                                            </FormGroup>
                                        </div>
                                    </div> */}
                                </ModalBody>
                                <ModalFooter>
                                    <div className="col-md-6 pull-left text-left">
                                        Fields marked with * are mandatory
                                    </div>
                                    <div className="col-md-6">
                                    {this.state.action_type == 'Add New User'?
                                    <Button color="primary" onClick={this.addUser.bind(this)}>Add User</Button>
                                    : null }
                                    <Button color="secondary"
                                            onClick={this.toggleNewUserModel.bind(this)}>Cancel</Button>


                                    </div>
                                </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.newBrandModel} toggle={this.toggleNewBrandModel.bind(this)} >
                    <ModalHeader toggle={this.toggleNewBrandModel.bind(this)}>Add New Brand</ModalHeader>
                                <ModalBody className="user_form_fields">
                                    <h5>Brand Details</h5>
                                    <div className="row">
                                        
                                        <div className="col-md-6 col-xs-12">
                                            <FormGroup>
                                                <Label for="brandName">Brand Name*</Label>
                                                <Input id="brandName" name="brandName" value={this.state.brandName}
                                                       onChange={this.onChangeInput.bind(this)}/>
                                                {/* {this.validator.message('brandName', this.state.brandName, 'required')} */}
                                            </FormGroup>
                                        </div>
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <div className="col-md-6 pull-left text-left">
                                        Fields marked with * are mandatory
                                    </div>
                                    <div className="col-md-6">
                                    
                                    <Button color="primary" onClick={this.addBrand.bind(this)}>Add Brand</Button>
                                    
                                    <Button color="secondary"
                                            onClick={this.toggleNewBrandModel.bind(this)}>Cancel</Button>


                                    </div>
                                </ModalFooter>
                </Modal>
            </div>
            </div>
        );
    }
}

export default Onboarding;